import React from "reactn";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";

// images
import Icon from "../icons/ReturnIcons";

// hooks
import appHook from "../../../hooks/appHook";

import FormGroup from "shared-anpost-components/components/form/form_group/FormGroup";
import InputGroup from "shared-anpost-components/components/form/input_group/InputGroup";
import Input from "shared-anpost-components/components/form/input/Input";
import FieldError from "shared-anpost-components/components/form/fieldError/FieldError";
import Label from "shared-anpost-components/components/form/label/Label";
import AddressLookUpList from "./AddressLookUpList";
import TextareaStyled from "./Textarea.styled";

const AddressLookUpView = ({
    addressId,
    innerTitle,
    handleBlur,
    handleKeyup,
    manualForm,
    values,
    errors,
    textarea,
    reformattedAddress,
    editAddress,
    manualEntry,
    addressLookUp,
    addresses,
    disableManualEntry,
    handleSelect,
    cancelLookUp,
    addressListMessage,
    manuallyEnter
}) => {
    const { handleFocus, focus } = appHook();
    return (
        <>
            <FormGroup focused={focus === addressId ? true : !!(false || values[addressId])}>
                <InputGroup>
                    {textarea ? (
                        <TextareaStyled>
                            {innerTitle !== "" && (
                                <>
                                    <p>
                                        <strong>{innerTitle}</strong>
                                    </p>
                                </>
                            )}
                            <p>
                                {reformattedAddress &&
                                    reformattedAddress.map(item => {
                                        return <span key={item}>{item}</span>;
                                    })}
                            </p>
                            <button type="button" onClick={editAddress}>
                                <Icon src="editIcon" />
                                Edit
                            </button>
                        </TextareaStyled>
                    ) : (
                        !manualEntry && (
                            <FormGroup error={errors[addressId]}>
                                <InputGroup error={errors[addressId]}>
                                    <Label htmlFor={addressId} text="Start typing address or Eircode" />
                                    <Input
                                        id={addressId}
                                        type="text"
                                        name={addressId}
                                        change={e => addressLookUp(e.target.value)}
                                        keyup={handleKeyup}
                                        keypress={e => {
                                            if (e.key.toUpperCase() === "ENTER") e.preventDefault();
                                        }}
                                        focus={handleFocus}
                                        blur={handleBlur}
                                        value={values[addressId] || ""}
                                        autoComplete="no-autocomplete"
                                        required
                                        maxLength="100"
                                    />
                                </InputGroup>
                                {errors[addressId] && <FieldError error={errors[addressId]} />}
                            </FormGroup>
                        )
                    )}
                </InputGroup>

                {addresses.length !== 0 && (
                    <AddressLookUpList
                        disableManualEntry={disableManualEntry}
                        handleSelect={handleSelect}
                        addresses={addresses}
                        manuallyEnter={manuallyEnter}
                        handleCancel={cancelLookUp}
                        message={addressListMessage}
                    />
                )}
            </FormGroup>
            {manualEntry && <>{manualForm}</>}
        </>
    );
};

export default withRouter(AddressLookUpView);

// props validation
AddressLookUpView.propTypes = {
    addressId: PropTypes.string,
    innerTitle: PropTypes.string,
    handleBlur: PropTypes.func,
    handleKeyup: PropTypes.func,
    manualForm: PropTypes.any,
    values: PropTypes.object,
    errors: PropTypes.object,
    textarea: PropTypes.bool,
    reformattedAddress: PropTypes.array,
    editAddress: PropTypes.func,
    manualEntry: PropTypes.bool,
    addressLookUp: PropTypes.func,
    addresses: PropTypes.array,
    disableManualEntry: PropTypes.bool,
    handleSelect: PropTypes.func,
    cancelLookUp: PropTypes.func,
    addressListMessage: PropTypes.string,
    manuallyEnter: PropTypes.func
};
